/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BaseMongoEntity } from './baseMongoEntity';
import { EntityStatus } from './entityStatus';


export interface Subscriber extends BaseMongoEntity { 
    username?: string;
    phoneNumber?: string;
    pincode?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    fullName?: string;
}
